"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactFontawesome = require("@fortawesome/react-fontawesome");

var _reactRedux = require("react-redux");

var _actions = require("kmap-redux/dist/actions");

var _Button = _interopRequireDefault(require("../../components/Button"));

var _MenuTab = _interopRequireDefault(require("../../components/MenuTab"));

var _messageActions = require("../../actions/messageActions");

var _infoboxActions = require("../../actions/infoboxActions");

var _bookmarkActions = require("../../actions/bookmarkActions");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var SearchPanel = function SearchPanel() {
  var _useState = (0, _react.useState)(),
      _useState2 = _slicedToArray(_useState, 2),
      activeMenu = _useState2[0],
      setActiveMenu = _useState2[1];

  var _useState3 = (0, _react.useState)(),
      _useState4 = _slicedToArray(_useState3, 2),
      suggestedAddresses = _useState4[0],
      setSuggestedAddresses = _useState4[1];

  var _useState5 = (0, _react.useState)(''),
      _useState6 = _slicedToArray(_useState5, 2),
      searchValue = _useState6[0],
      setSearchValue = _useState6[1];

  var ref = /*#__PURE__*/_react.default.createRef();

  var dispatch = (0, _reactRedux.useDispatch)();
  var bookmarks = (0, _reactRedux.useSelector)(function (state) {
    return state.loadBookmarksReducer.bookmarks;
  });
  var visible = (0, _reactRedux.useSelector)(function (state) {
    return state.menuReducer.currentMenu === 'SEARCH';
  });
  (0, _react.useEffect)(function () {
    dispatch((0, _bookmarkActions.loadBookmarks)());
  }, [dispatch]);

  var plotAddress = function plotAddress(address) {
    dispatch((0, _actions.goToAddress)(address)).then(function (kGeometry) {
      kGeometry.geometry.on('click', function () {
        dispatch((0, _infoboxActions.selectAddress)(kGeometry));
      });
    }).catch(function (e) {
      dispatch({
        type: _messageActions.SHOW_MESSAGE,
        message: e.message
      });
    });
  };

  var suggestionClickHandler = function suggestionClickHandler(suggestion) {
    setSearchValue(suggestion);
    plotAddress(suggestion);
    setSuggestedAddresses(undefined);
  };

  (0, _react.useEffect)(function () {
    var clickHandler = function clickHandler(e) {
      var _ref$current;

      if (!((_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.contains(e.target))) {
        setSuggestedAddresses(undefined);
      }
    };

    document.addEventListener('mousedown', clickHandler);
    return function () {
      document.removeEventListener('mousedown', clickHandler);
    };
  }, [ref]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: 'SearchPanel',
    style: {
      display: visible ? 'block' : 'none'
    }
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: 'search-label'
  }, "Search an address, location or county"), /*#__PURE__*/_react.default.createElement("div", {
    ref: ref,
    className: 'search-area'
  }, /*#__PURE__*/_react.default.createElement("textarea", {
    disabled: false,
    id: "searchAddressBox",
    name: "address",
    value: searchValue,
    onChange: function onChange(event) {
      var nextValue = event.target.value;
      setSearchValue(nextValue);
      if (nextValue.length > 2) dispatch((0, _actions.searchAddress)(nextValue)).then(function (response) {
        return setSuggestedAddresses(response.results);
      });
    }
  }), /*#__PURE__*/_react.default.createElement("div", {
    id: 'suggestion-list'
  }, suggestedAddresses === null || suggestedAddresses === void 0 ? void 0 : suggestedAddresses.map(function (address, index) {
    return /*#__PURE__*/_react.default.createElement("span", {
      role: 'button',
      onKeyDown: function onKeyDown(e) {
        if (e.keyCode === 13) suggestionClickHandler(address);
      },
      onClick: function onClick() {
        return suggestionClickHandler(address);
      },
      tabIndex: index,
      className: 'suggestion-item',
      key: "address-".concat(index)
    }, address);
  }))), /*#__PURE__*/_react.default.createElement(_Button.default, {
    classNames: ['search-panel-buttons'],
    onClick: function onClick() {
      if (searchValue.length > 0) plotAddress(searchValue);
    }
  }, "Search"), /*#__PURE__*/_react.default.createElement(_Button.default, {
    classNames: ['search-panel-buttons'],
    onClick: function onClick() {
      setSearchValue('');
      dispatch((0, _actions.deleteAllSpecialMarkers)());
    }
  }, "Clear"), /*#__PURE__*/_react.default.createElement(_MenuTab.default, {
    title: 'BOOKMARKS',
    icon: /*#__PURE__*/_react.default.createElement(_reactFontawesome.FontAwesomeIcon, {
      icon: ['fas', 'star'],
      color: 'white'
    }),
    onToggle: function onToggle() {
      if (activeMenu === 'BOOKMARKS') setActiveMenu('');else setActiveMenu('BOOKMARKS');
    },
    open: activeMenu === 'BOOKMARKS'
  }, /*#__PURE__*/_react.default.createElement("div", {
    id: 'bookmark-content'
  }, bookmarks.length === 0 && /*#__PURE__*/_react.default.createElement("span", null, "This is where your saved bookmarks will appear."), bookmarks.map(function (bookmark, index) {
    return /*#__PURE__*/_react.default.createElement("span", {
      role: 'button',
      onKeyDown: function onKeyDown(e) {
        if (e.keyCode === 13) dispatch((0, _bookmarkActions.plotBookmark)(bookmark));
      },
      onClick: function onClick() {
        return dispatch((0, _bookmarkActions.plotBookmark)(bookmark));
      },
      tabIndex: index,
      className: 'bookmark-item',
      key: bookmark.address
    }, bookmark.alias ? bookmark.alias : bookmark.address);
  }))));
};

var _default = SearchPanel;
exports.default = _default;